import { useMemo } from 'react';
import { useDi, API_BASE_URL } from '../../app/providers/DiProvider';
import { ContentApi } from './content.api';

/** Resolves the ContentApi client from the DI container (base URL comes from env). */
export function useContentApi(): ContentApi {
  const di = useDi();
  return useMemo(() => new ContentApi(di.resolve(API_BASE_URL)), [di]);
}
